import Loader from '../../../../components/Loader';
import Input from '../../../../components/form-control/Input';
import Button from '../../../../components/form-control/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { getARoleByID, getAllPermissions } from '../../../../api/requests';
import BackButton from '../../../../components/BackButton';
import { useQuery } from '@tanstack/react-query';
import RoleList from './RoleList';
import { getFormattedDate, showToast } from '../../../../utils/miscFunctions';



const RoleDetails = () => {
  const params = useParams();
  const roleId = params.id;
  const navigate = useNavigate();

  const { data: roleData, isLoading: isLoadingRole } = useQuery({
    queryKey: ['fetchRole', roleId],
    queryFn: () => fetchRole()
  });

  const { data: permissionsData, isLoading: isLoadingPermissions } = useQuery({
    queryKey: ['fetchPermissions'],
    queryFn: () => fetchPermissions()
  });

  const fetchRole = async () => {
    if (!roleId) return;

    try {
      const response: any = await getARoleByID(roleId);
      if (response) {
        return response;
      }
    } catch (error: any) {
      showToast.error(error.description);
    }
  };

  const fetchPermissions = async () => {
    try {
      const response: any = await getAllPermissions();
      if (response) {
        return response;
      }
    } catch (error: any) {
      showToast.error(error.description);
    }
  };

  // const ScopesList = () => {
  //   const elements: JSX.Element[] = [];
  //   const _permissions = Object.entries(permissionsData);
  //   const transformedArray = _permissions.map(([key, value]) => ({
  //     key: key,
  //     value: value
  //   }));
  //   const _transformedArray = transformedArray.sort((a, b) => a.key.localeCompare(b.key));

  //   _transformedArray.forEach((permission, index) => {
  //     elements.push(
  //       <div key={index}>
  //         <ScopeComponent
  //           label={permission.value as string}
  //           scope={permission.key}
  //           checked={roleData?.scopes?.map((scope: any) => scope?.key).includes(permission?.key)}
  //           onChange={(isChecked) => { }}
  //           disabled
  //         />
  //       </div>
  //     );
  //   });

  //   return <div className="grid grid-cols-1 md:grid-cols-2">{elements}</div>;
  // };

  return (
    <div className="">
      {isLoadingRole || isLoadingPermissions ? (
        <div className="h-screen flex items-center justify-center">
          <Loader message="Loading. Please wait..." brollyLoaderFixed />
        </div>
      ) : (
        <div className="bg-white rounded">

          <div className="p-5 flex gap-5 items-center">
            <BackButton onClick={() => navigate('/admin/settings?tab=roles')} />
            <h1 className="font-bold">{roleData?.name}</h1>
          </div>

          <hr />

          <div className="grid grid-cols-1 md:grid-cols-5  justify-around gap-10 p-10">
            <div className="col-span-2">
              <div className="flex items-center justify-between">
                <h1 className="font-semibold my-2">Role details</h1>
                <span className="text-gray-400 text-xs block">
                  Last modified on {roleData?.updatedOn ? getFormattedDate({ date: roleData?.updatedOn, showTime: true }) : '-'}
                </span>
              </div>

              <hr />

              <div className="py-5">
                <>
                  <span className="text-sm">Name of role</span>
                  <div className="border p-2 rounded">{roleData?.name}</div>
                </>
                <div className="py-5">
                  <span className="text-sm">Role description</span>
                  <div className="text-sm border py-2 px-3 min-h-[8rem] rounded">
                    {roleData?.description}
                  </div>
                </div>
                <hr />

                <div className="pt-5">
                  <span className="text-sm">Invite a new team member to this role</span>
                  <div className="flex items-center justify-center gap-0">
                    <Input placeholder="email address" className="rounded-r-none h-[40px]" />
                    <div className="">
                      <Button label="Send invite" className="bg-primary-main rounded-l h-[42px]" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="border rounded p-5 col-span-3">
              <h1 className="font-semibold my-2">Role permissions</h1>
              <hr />
              <>
                <div className="my-3">
                  <span className="text-sm">
                    See the list of available permissions for this role
                  </span>
                </div>
                {/* <ScopesList /> */}
                <RoleList isByCompanyType={false} />
              </>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RoleDetails;


